import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'posts',
            name: 'post',
            class: 'Modules\\Post\\Entities\\Post'
        }
    }
}